import {CustomDataSource} from 'cesium';
import {transformGeometry} from "../feature-layer/createFeatureCollection";
import {isString, isObject, isArray} from "lodash";
import Polyline from "../polyline/Polyline";

//纹理图绘制
function getColorRamp(elevationRamp) {
    let ramp = document.createElement('canvas');
    ramp.width = 100;
    ramp.height = 1;
    let ctx = ramp.getContext('2d');

    let grd = ctx.createLinearGradient(0, 0, 100, 0);

    elevationRamp.map(v => {
        grd.addColorStop(v[0], v[1]);
    })

    ctx.fillStyle = grd;
    ctx.fillRect(0, 0, 100, 1);
    return ramp;
}
export default class GradationLineLayer extends CustomDataSource {
    constructor(option) {
        const {data, key, labelField, template, color, width} = option;

        super();

        // 图层标识
        this.key = key;

        // 图层名称
        this.name = name;

        // 标签字段
        this.labelField = labelField;

        // 模版内容
        this.template = template;

        this.data = data;

        // 默认线宽度
        this.width = width || 3;

        // 颜色
        this.color = color || '#0080ff';

        if (data?.length) {
            this.loadData(data)
        }
    }

    loadData(data) {
        this.entities.removeAll();

        data.map(v => {
            const {geometryInfo, colors, width} = v;
            const {coordinates} = transformGeometry(geometryInfo);
            const entity = this.entities.add(new Polyline({
                geometry: coordinates,
                properties: v,
                style: {
                    width: width || this.width,
                    material: getColorRamp(colors)
                }
            }))

            entity.type = this.modalType || this.key;
            entity.key = this.key;
            entity.properties = v.properties || {};
        })
    }
}
